import InputControl from "@/models/BaseModelInputControl.js";
import $ from "jquery";
import _ from "lodash";
import jsonUtil from "./jsonUtil";
import funcUtil from "./funcUtil";
//import auth from "./auth"
import JSZip from "jszip";
import FileSaver from "file-saver";
import axios from "axios";
import { mapGetters, mapActions, mapState } from "vuex";
import jwt_decode from 'jwt-decode'
import sprLib from "sprestlib";
sprLib.baseUrl(process.env.VUE_APP_siteUrl);


let nextquery = { prevId: "0", maxItems: "5000" };

self = this;
export default {
	name: "apiUtil",
	vm: {},
	mixins: [jsonUtil, funcUtil],
	computed: {
		auth: function(){
			return this.$root.$eumAuth;
		  }
	
	},
	methods: {
		_setVmInApiUtil(rootapp){
			this.vm = rootapp;
		},
		decodeURIComponentSafe(str) {
			if (!str) { return str; }
			return decodeURIComponent(str.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'));
		},

		_decodeResponseObject(result) {
			for(let i =0; i < result.length; i++){
				for(let j=0; j < Object.keys(result[0]).length; j++){
					let temp = Object.keys(result[i])[j];
					if(typeof Object.values(result[i])[j] == 'string'){
						result[i][temp] =this.decodeURIComponentSafe(Object.values(result[i])[j]);
					}
				}
			} 
			return result;
		},
		_getToken(){
			//let token = localStorage.getItem('.eum.file_token');
			//token = auth.acquireIdToken();
			//token.then(//console.log(`  ---  _getToken() token -> `,token.response));
			return vm.$store.getters['authModule/api_idtoken']
			
		},
		 _getItems(config, query) {
			//console.log(`[apiUtil] _getItems starting for list ${config.list}`)
			////console.log(query);
			////console.log("_getItems***");
			// Input: config data model object and optional query object { filter: string, limit: number }
			//				filter string is in OData format: e.g. "Id gt 1 and (Title eq 'test a' or Age lt 50)"
			// Action: performs an API call to SharePoint list using a 3rd party library - sprLib
			// Return: a promise that will return an array
			// Dependency: jsonUtil._getLocalRequest
			const self = this;
			////console.log(" --------------- process.env.NODE_ENV = ["+process.env.NODE_ENV+"]");
			const objectToQuery = {
				listCols: config.columns,
				queryNext: nextquery,
				metadata: true,
			};

			if (query) {
				////console.log("     has query ==> "+ query);
				objectToQuery.queryFilter = (query.filter) ? query.filter : "";
				objectToQuery.queryLimit = (query.limit) ? query.limit : 5000;
			} else {
				//if Query is not passed
				////console.log("     has NO query");
				objectToQuery.queryFilter = "";
				objectToQuery.queryLimit = 5000;
			}

			//let localRequestold = `${process.env.bas}/_api/lists/getbytitle('${config.list}')/items`;
			//let localRequest = `/_api/lists/getbytitle('${config.list}')/items`;
			let localRequest = `/api/${config.list}`;
			
			localRequest += (query) ? self._getLocalRequest(query) : "";
			////console.log(`${Date.now()}-mytag----- [apiUtil] _getItems() -- going to call CUSTOMAXIOS `)
			let result =  vm.$http.get(localRequest).then((response) => response.data)
			////console.log(result)
			////console.log('----------------------------------------------------------------------------')
			////console.log('');
			return result;
			//return this._decodeResponseObject(result);
		},


		async _getExtendedItems(config, query) {
			//console.log("[apiUtil] _getExtendedItems starting")
			// Input: config data model object and optional query object { filter: string, limit: number }
			//				filter string is in OData format: e.g. "Id gt 1 and (Title eq 'test a' or Age lt 50)"
			// Action: attaches extended list configs and performs an API call to SharePoint list 
			//				 "extended" means the lookup lists: e.g. Relation list has a lookup Program column, then Program list is being extended
			// Return: a promise that will return an array
			// Dependency: _getItems
			const self = this;

			if (config.extends) {
				const extConfig = Object.assign({}, config);
				Object.entries(config.extends).forEach((extList) => {

					Object.entries(extList[1]).forEach((extCol) => {
						if (["string", "number", "date"].indexOf(extCol[1].type) !== -1) {
							const key = extList[0] + extCol[0];
							const value = {
								class: "lookup",
								dataName: `${extList[0]}/${extCol[1].dataName}`,
								type: extCol[1].type,
								title: `${extList[0]} ${extCol[1].title}`,
								width: extCol[1].width,
								hidden: extCol[1].hidden,
								readOnly: extCol[1].readOnly,
								// column: false
							};
							extConfig.columns[key] = value;
						}
					});

				});
				return await self._getItems(extConfig, query);

			} else {
				return await self._getItems(config, query);
			};
		},
		async _getAllItemsUnbundled(){
			//console.log("[apiUtil.js] _getAllItemsUnbundled() starting");
			const self = this;
			const lists = Object.keys(bundledObject);
			const props = Object.values(bundledObject);
			const resources = _.zipObject(lists, props.map(object => self._getExtendedItems(object.config, object.query)));
			//console.log("[apiUtil.js] _getAllItemsUnbundled() ending");
			
		},
		async _getAllItems(bundledObject) {
			// Input: an object with _getItems' args as properties { program: {config: object, query: object} }
			// Action: bundle all requests to call SharePoint API and resolve after all calls are successful
			// Return: a promise that will return an object with _getItems' returns as properties
			// Dependency: _getExtendedItems, lodash
			//console.log("[apiUtil.js] _getAllItems() starting");
			const self = this;
			const lists = Object.keys(bundledObject);
			const props = Object.values(bundledObject);
			const resources = _.zipObject(lists, props.map(object => self._getExtendedItems(object.config, object.query)));
			return _.zipObject(Object.keys(resources), await Promise.all(Object.values(resources)));
		},


		async _getJoinedItems(joinedObject) {
			// Input: an object { parentId: number, parentConfig: object, keyToJoin: string, childConfigs: array}
			// Action: performs an API call for an item by Id and multiple API calls to its lookup lists
			// Return: a promise that will return an object with "parent" property having an array of one parent item and "children" property having an array of _getAllItems' returns 
			// Dependency: _getAllItems, _getExtendedItems, lodash
			const self = this;
			const lists = joinedObject.childConfigs.map(config => config.list);
			const objects = joinedObject.childConfigs.map(config => {
				return {
					config: config,
					query: {
						filter: `${joinedObject.keyToJoin} eq ${joinedObject.parentId}`
					}
				}
			});
			const resources = _.zipObject(lists, objects)
			const [head] = await self._getExtendedItems(joinedObject.parentConfig, {
				filter: `Id eq ${joinedObject.parentId}`
			});

			return {
				parent: head,
				children: await self._getAllItems(resources)
			};
		},


		async _getInputControls(config, key) {
			// Input: optional config data model object and optional key string
			// Action: performs an API call to get all input controls
			// Return: a promise that will return an object of arrays
			// Dependency: _getItems, lodash
			const self = this;
			const config2 = (config) ? config : InputControl;
			const key2 = (key) ? key : 'Field';
			const response =  await self._getItems(config2, "");
			return _.groupBy(response, key2);
		},


		async _updateItems(config, updateData) {
			const columnsToUpdate = {};
			
			Object.entries(config.columns)
				.forEach((item) => {
					if (!item[1].readOnly) {
						// if(item[1].type === 'string'){
						// 	updateData[item[0]] = encodeURIComponent(updateData[item[0]]);
						// }
						if (item[1].dataName === "File/Name") {
							columnsToUpdate["FileLeafRef"] = updateData[item[0]]
						} else if (item[1].multi) {
							columnsToUpdate[item[0]] = typeof updateData[item[0]] == "string" ? updateData[item[0]] : (updateData[item[0]]) ? updateData[item[0]].toString() : null
						} else if (item[1].type === 'date') {
							columnsToUpdate[item[0]] = (updateData[item[0]] == "") ? null : updateData[item[0]]
						}
						else {
							columnsToUpdate[item[0]] = updateData[item[0]]
						}
					}
				});

				////console.log(`${Date.now()}-mytag----- [apiUtil] _updateItems() -- going to use AXIOS `)
				return vm.$http
					.put(`${process.env.VUE_APP_baseUrl}/api/${config.list}/${columnsToUpdate.Id}`, updateData)
					.then((response) => response.data)
		},


		async _updateAllItems(bundledObject) {
			// Input: objects with _updateItems' args as properties { program: {config: BaseModelProgram, updateData: objectData},
			//  partner: {config: BaseModelPartner, updateData: objectData}
			//	}
			// Action: bundle all requests to call SharePoint API and resolve after all calls are successful		
			// Dependency: _updateItems(), lodash
			const self = this;
			//const lists = Object.keys(bundledObject);
			const props = Object.values(bundledObject);

			let updateCount = 1;
			const resources = []

			for (const item in props) {
				const config = props[item].config;
				const processInBatches = props[item].processInBatches ? true : false;
				for (const data in props[item].updateData) {
					if (updateCount % process.env.VUE_APP_BatchSize == 0 && processInBatches) {
						await self.sleep(process.env.VUE_APP_BatchTimeOut);
					}
					await self._updateItems(config, props[item].updateData[data])
						.then(response => { resources.push(response) });
					updateCount++;
				}
			}

			return resources
			//const resources = _.zipObject(lists, props.map(object => self._updateItems(object.config, object.updateData)));
			// const resources = _.zipObject(lists, props.map(object =>{
			// 	object.updateData.forEach(data =>{
			// 		self._updateItems(object.config,data)
			// 	})
			// })
			// );

			// return _.zipObject(Object.keys(resources), await Promise.all(Object.values(resources)));
		},

		async _createItems(config, createData) {
			// Input: config data model object and a createData object.		
			//e.g.: _createItems(BaseModelProgram,datatoUpdateProgram);	
			const columnsToCreate = {};
			Object.entries(config.columns)
				.forEach((item) => {
					if (item[0] != "Id" && !item[1].readOnly) {
						// if(item[1].type === 'string'){
						// 	createData[item[0]] = encodeURIComponent(createData[item[0]]);
						// }
						if (item[1].multi) {
							columnsToCreate[item[0]] = typeof createData[item[0]] == "string" ? createData[item[0]] : (createData[item[0]]) ? createData[item[0]].toString() : null
						} else if (item[1].type === 'date') {
							columnsToCreate[item[0]] = (createData[item[0]] == "") ? null : createData[item[0]]
						} else {
							columnsToCreate[item[0]] = createData[item[0]]
						}
					}
				});

				return vm.$http
				.post(`${process.env.VUE_APP_baseUrl}/api/${config.list}`, columnsToCreate)
				.then((response) => response.data)
		},
		async sleep(ms) {
			return new Promise(resolve => {
				setTimeout(resolve, ms);
			});
		},
		async _createAllItems(bundledObject) {
			// Input: objects with _createItems' args as properties { program: {config: BaseModelProgram, createData: objectData},
			//  partner: {config: BaseModelPartner, createData: objectData}
			//	}
			// Action: bundle all requests to call SharePoint API and resolve after all calls are successful		
			// Dependency: _createItems(), lodash
			let self = this;
			//let lists = Object.keys(bundledObject);
			let props = Object.values(bundledObject);
			let createCount = 1;

			const resources = []

			for (const item in props) {
				const config = props[item].config;
				const processInBatches = props[item].processInBatches ? true : false;
				for (const data in props[item].createData) {
					let start = Date.now();
					if (createCount % process.env.VUE_APP_BatchSize == 0 && processInBatches) {
						await self.sleep(process.env.VUE_APP_BatchTimeOut);
						//console.log("Awaited");
					}
					await self._createItems(config, props[item].createData[data])
						.then(response => { resources.push(response) })
					//console.log("TimeTaken for" + createCount, Date.now() - start);
					createCount++;

				}
			}

			return resources
		},


		async _createJoinedItems(joinedObject, createData, ParentKey) {
			// e.g. 	_createJoinedItems({
			// 	parentConfig: BaseModelProgram, 				
			// 	childConfigs: [DataRelationship, BaseModelUnitClass]
			// }, createData)
			// 1. first it creates the parent. if parent creation is successful it grabs the ProgramId
			// 2. We inject that ProgramId to childdata and call create
			// Dependency: _createAllItems, lodash
			// To-Do - If neede we can pass the parent key from front. right now its hardcoded to ProgramId
			let self = this, resources = []
			let childData = createData.children;
			let createdParent = await self._createItems(joinedObject.parentConfig, createData.parent);

			if (typeof createdParent != "undefined") {
				for (let key in childData) {
					childData[key].forEach((items) => { items[ParentKey] = createdParent.Id })
				}

				let lists = joinedObject.childConfigs.map(config => config.list);
				let objects = joinedObject.childConfigs.map(config => {
					return {
						config: config,
						createData: childData[config.list]
					}
				});

				resources = _.zipObject(lists, objects)
			}

			return await self._createAllItems(resources)
		},


		async _deleteItems(config, deleteData) {
			return vm.$http.delete(`${process.env.VUE_APP_baseUrl}/api/${config.list}/${deleteData.Id}`)
			.then((response) => response)
		},


		async _deleteAllItems(bundledObject) {
			// this can handle multiple delete requests
			let self = this;
			//let lists = Object.keys(bundledObject);
			let props = Object.values(bundledObject);
			let deleteCount = 1;

			const resources = []

			for (const item in props) {
				const config = props[item].config
				const processInBatches = props[item].processInBatches ? true : false
				for (const data in props[item].deleteData) {
					if (deleteCount % process.env.VUE_APP_BatchSize == 0 && processInBatches) {
						await self.sleep(process.env.VUE_APP_BatchTimeOut);
					}
					await self._deleteItems(config, props[item].deleteData[data])
						.then(response => { resources.push(response) });
					deleteCount++;
				}
			}

			return resources
		},


		async _postAllFilesAndUpdateMetadata(config, aryFileMetadata) {
			// example to call the _postAllFilesAndUpdateMetadata() method and get the response array:
			// const config = { list: "Workbook" }				
			// _postAllFilesAndUpdateMetadata(config, fileArray).then(function (responseArray) {			
			// 	//console.log("output of files:");
			// 	//console.log(responseArray);
			// }); 
			// Input: config will have the list object and aryFileMetadata will have the multiple file object which are uploaded from the page
			// Dependency: _postFileAndUpdateMetadata()
			//console.log("========== _postAllFilesAndUpdateMetadata");
			//console.log("config => ");
			//console.log(config);
		
			//console.log("aryFileMetadata=> ");
			//console.log(aryFileMetadata);
			const self = this;
			const returnResponseArrayData = [];
			try {
				aryFileMetadata.forEach(fileData => {
					returnResponseArrayData.push(self._postFileAndUpdateMetadata(config, fileData));
				});
				return await Promise.all(returnResponseArrayData);
			} catch (err) {
				//console.log(err);
				return returnResponseArrayData;
			}
		},


		async _postFileAndUpdateMetadata(config, fileMetadata) {
			// Input: config will have the list object and fileMetadata will have the single file which is uploaded from the page				
			// Dependency: _postFile(),  _getItemFromFileUri(),  _updateItemFromFile()
			//console.log("  . . . . . . . . . _postFileAndUpdateMetaData");
			//console.log(" . . . . . . . . . . config=>");
			//console.log(config);

			const self = this;
		
			let rspToReturn = {
				Id: fileMetadata.Id,
				status: "failed"
			};
			let theItem;
			let rspPostFile = await self._postFile(config, fileMetadata);
		
			if (rspPostFile.status == "success") {
					
					if (config.list.toLowerCase() === "documents") {

						//theItem = rspPostFile.data[0].Value.d;
						theItem = rspPostFile.data.data;
						let rspGetListItem = await self._getItemFromFileUri(theItem);

						const rspUpdateListItem = await self._updateItemFromFile(config, fileMetadata, rspGetListItem.data);
						if (rspUpdateListItem.status == "success") {
							rspToReturn.status = "success";
						}
					} else if ( config.list.toLowerCase() === "bulkuploadaudit"){
						rspToReturn.status = "success";
					}
					
				} else {
					console.log(` APIUTIL error`);
					
				}

			;
			return rspToReturn;
		},


		async _readFileAsArray(file) {
			const reader = new FileReader();
			return new Promise((resolve, reject) => {
				reader.onerror = () => {
					reader.abort();
					reject();
				};
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.readAsArrayBuffer(file);
			});
		},


		async _postFileOrig(config, fileMetadata) {
			//console.log("  . . . . . . . . . . . . ._postFileAndUpdateMetaData");
			//console.log(" . . . . . . . . . . . . . .config=>");
			//console.log(config);
			//console.log(" . . . . . . . . . . . . . .fileMetadata=>");
			//console.log(fileMetadata);
			const self = this;
			const fileReadyToUpload = await self._readFileAsArray(fileMetadata.FileContent)
			//console.log(" . . . . . . . . . . . . . .fileMetadata.ProgramId=>");
			//console.log(fileMetadata.ProgramId);
			
			//console.log(" *** _postFile() *** list [" + config.list + "]");
			if (process.env.NODE_ENV === "production" || 1 == 1) {
				let tkn = await this._getToken();
				//console.log(" postFile - PROD - updated url");
				let theurl = `${process.env.VUE_APP_baseUrl}/api/${config.list}/postfile/${fileMetadata.File}?pid=${fileMetadata.ProgramId}&ptid=${fileMetadata.PartnerId}&tid=${fileMetadata.TransactionID}&dtype=${fileMetadata.DocumentType}&be=${fileMetadata.BusinessEvent}`;
				//console.log(" =====> " + theurl);
				return sprLib
					.rest({
						headers: {Authorization: 'Bearer ' + tkn },
						url: theurl,
						type: "POST",
						data: fileReadyToUpload
					}).then((response) => {
						//console.log(response);
						return {
							data: response,
							status: "success"
						};
					})
					.catch((err) => {
						//console.log(err);
						return {
							Id: fileMetadata.Id,
							status: "failed"
						};
					});

			} else {
				//console.log(" postFile - NON-PROD");
				return {
					status: "success",
					data: [{
						ListItemAllFields: {
							__deferred: {
								uri: "https://tts-analytics.ey.com/sites/TishmanSpeyer/_api/Web/GetFileByServerRelativeUrl('/sites/TishmanSpeyer/Workbook/index.aspx')/ListItemAllFields"
							}
						}
					}]
				};
			}
		},


		async _uploadFile(config,fileMetadata){
			let tkn = await this._getToken();
			//let tkn = localStorage.getItem('.eum.file_token');
			let formData = new FormData();
			
			formData.append('file', fileMetadata.FileContent, fileMetadata.File);
			formData.append('fileInfo',fileMetadata);
			let theurl = `/api/${config.list}`;

			return vm.$http.post(theurl, formData, 
				{
					headers: {
					'Authorization': `Bearer ${tkn}`,
					'Content-Type': `multipart/form-data`
					}
				});
				

		},
		async _postFile(config, fileMetadata) {
		
			//console.log(" . . . . . . . . . . . . . .config=>");
			//console.log(config);
			//console.log(" . . . . . . . . . . . . . .fileMetadata=>");
			//console.log(fileMetadata);
			const self = this;
			const fileReadyToUpload = await self._readFileAsArray(fileMetadata.FileContent)
			//console.log(" . . . . . . . . . . . . . .fileMetadata.ProgramId=>");
			//console.log(fileMetadata.ProgramId);
			
			//console.log(" *** _postFile() *** list [" + config.list + "]");
			if (process.env.NODE_ENV === "production" || 1 == 1) {
				
			//	let tkn = await this._getToken();
			    let tkn = localStorage.getItem('.eum.file_token');
				let formData = new FormData();
				
				formData.append('file', fileMetadata.FileContent, fileMetadata.File);
				formData.append('fileInfo',fileMetadata);

				//console.log('>> formData >> ',formData);
				//console.log(" postFile - PROD - updated url");
				let theurl;
				//if ( fileMetadata.ProgramIdList != null ){
			    if ( fileMetadata.BatchGUID != null && fileMetadata.BatchGUID > 0){	
					theurl = `/api/${config.list}/postfile/${fileMetadata.File}?bg=${fileMetadata.BatchGUID}&pidl=${fileMetadata.ProgramIdList}&ptidl=${fileMetadata.PartnerIdList}&tid=${fileMetadata.TransactionID}&dtype=${fileMetadata.DocumentType}&be=${fileMetadata.BusinessEvent}`;

				} else {
					theurl = `/api/${config.list}/postfile/${fileMetadata.File}?pid=${fileMetadata.ProgramId}&ptid=${fileMetadata.PartnerId}&tid=${fileMetadata.TransactionID}&dtype=${fileMetadata.DocumentType}&be=${fileMetadata.BusinessEvent}`;
				}
			
			
				//console.log(" =====> " + theurl);
				return vm.$http.post(theurl, formData, 
					{
						headers: {
						'Authorization': `Bearer ${tkn}`,
						'Content-Type': `multipart/form-data`
						}
						
					}
					
						
					).then((response) => {
					
						return {
							data: response,
							status: "success"
						};
					})
					.catch((err) => {
						
						return {
							Id: fileMetadata.Id,
							status: "failed"
						};
					});

			} else {
				//console.log(" postFile - NON-PROD");
				return {
					status: "success",
					data: [{
						ListItemAllFields: {
							__deferred: {
								uri: "https://tts-analytics.ey.com/sites/TishmanSpeyer/_api/Web/GetFileByServerRelativeUrl('/sites/TishmanSpeyer/Workbook/index.aspx')/ListItemAllFields"
							}
						}
					}]
				};
			}
		},

		async _getItemFromFileUri(fileRespData) {
			if (process.env.NODE_ENV === "production" || 1===1) {
			 let geturl =`${process.env.VUE_APP_baseUrl}${fileRespData.ServerRelativeUrl}/2`;
			
			//console.log("--- geturl ==>");
			//console.log(geturl);

			 return vm.$http
			    .get(geturl)
				.then((response) => {
					//console.log('_getItemFromFileUri after customAxios call...');
					//console.log(response);
					//console.log("_getItemFromFileUri", response);
					return {
							data: response,
							status: "success"
						   };
				}).catch((err) => {
					//console.log("_getItemFromFileUri", err);
					return {
						Id: fileData.Id,
						status: "failed"
					};
				})

				// return sprLib
				// 	.rest({
				// 		url: `${process.env.VUE_APP_baseUrl}${fileRespData.ServerRelativeUrl}`,
				// 		type: "GET",
				// 	}).then((response) => {
				// 		//console.log("_getItemFromFileUri", response);
				// 		return {
				// 			data: response,
				// 			status: "success"
				// 		};
				// 	})
				// 	.catch((err) => {
				// 		//console.log("_getItemFromFileUri", err);
				// 		return {
				// 			Id: fileData.Id,
				// 			status: "failed"
				// 		};
				// 	})
			} else {
				return {
					status: "success",
					data: [{
						Id: 1,
						DocumentType: "EY Tax Report",
						EntityId: 3
					}]
				}
			}
		},


		async _updateItemFromFile(config, fileMetadata, item) {
			if (process.env.NODE_ENV === "production" || 1===1) {
				//console.log(` ... _updateItemFromFile - fileMetadata:`,fileMetadata);
				//console.log(` ... _updateItemFromFile - item:`,item);
				const columnsToUpdate = {};
				columnsToUpdate["Id"] = item.data.Id // From DB After Upload
				Object.entries(config.columns)
					.forEach((item) => {
						if (!item[1].readOnly) {
							columnsToUpdate[item[0]] = fileMetadata[item[0]]
						}
					});
					let tkn = await this._getToken();
					let posturl = `${process.env.VUE_APP_ApiBaseUrl}/Documents/updateid/${item.data.FileName}?newId=${item.data.Id}`;
					//console.log(`posturl =>`,posturl);
					//				return customAxios
					//.put(`${process.env.VUE_APP_baseUrl}/api/${config.list}/${columnsToUpdate.Id}`, updateData)
				
				return vm.$http.post(posturl)
				.then(function (response) {
					//console.log(response);
					return {
						data: response,
						status: "success"
					};
				})
				.catch(function (err) {
					//console.log(err);
					return {
						Id: fileMetadata.Id,
						status: "failed"
					};
				})

				
				// 	return sprLib
				// .rest({
				// 	headers: {Authorization: 'Bearer ' + tkn },
				// 	url: 'https://localhost:5001/api/documents/updateid/' + item.data.FileName + '?newId=' + item.data.Id,
				// 	type: 'POST'
				// }) // .list(config.list)
				// 	// .update(columnsToUpdate)
				// 	.then(function (response) {
				// 		//console.log(response);
				// 		return {
				// 			data: response,
				// 			status: "success"
				// 		};
				// 	})
				// 	.catch(function (err) {
				// 		//console.log(err);
				// 		return {
				// 			Id: fileMetadata.Id,
				// 			status: "failed"
				// 		};
				// 	})

			} else {

				return {
					status: "success"
				}
			}
		},
		

		async _deleteFile(deleteFileData) {
			//console.log(" === apiUtil.js   _deleteFile(deleteFileData) ===")
			//console.log(deleteFileData);
			// this function will delete file on sharepoint.
			// we need to pass FileServerRelativeUrl to make delete work. 
			// We don't need to pass config here as FileServerRelativeUrl has all necessary file info.
			if (process.env.NODE_ENV === "production" || 1==1) {
				return vm.$http.delete(`${process.env.VUE_APP_baseUrl}/api/documents/${deleteFileData.Id}?fileName=${deleteFileData.FileName}`)
					.then(response => {
						return {
							filename: deleteFileData.FileName,
							status: "deleted"
						}
					})
					.catch(err => {
						return {
							filename: deleteFileData.FileName,
							status: "failed"
						}
					})
			} else {
				//console.log(" === NOT PROD ");
				//TODO
			}
		},
		async _deleteAuditFile(FileData) {
			//console.log(" === apiUtil.js   _deleteFile(deleteFileData) ===")
			//console.log(deleteFileData);
			// deletes file from the SQL DB via the API
			if (process.env.NODE_ENV === "production" || 1==1) {
				let deleteUrl = `${process.env.VUE_APP_baseUrl}/api/bulkuploadaudit/tempname/${FileData.fileData.upload.uuid}`;
				return vm.$http.delete(deleteUrl)
					.then(response => {
						return {
							filename: FileData.fileData.upload.uuid,
							status: "_deleteAuditFile success"
						}
					})
					.catch(err => {
						return {
							filename: FileData.fileData.upload.uuid,
							status: "_deleteAuditFile failed"
						}
					})
			} else {
				//console.log(" === NOT PROD ");
				//TODO
			}
		},
		async triggerWorkflowByItemIds(itemIds) {
				if (itemIds !== null && itemIds.length > 0) {
					//console.log(`-----------------------------------------------------------------------------------------------`);
					//console.log(`--- triggerWorkflowByItemIds(${itemIds}) executing --------`);
					//console.log(`-----------------------------------------------------------------------------------------------`);
					
					itemIds.forEach(itemId => {

						//console.log(`        For itemId [${itemId}]`);
						sprLib
							.rest({
								url: `${process.env.VUE_APP_siteUrl}/_api/SP.WorkflowServices.WorkflowInstanceService.Current/StartWorkflowOnListItemBySubscriptionId(subscriptionId='${process.env.VUE_APP_IssuanceSubscriptionId}',itemId='${itemId}')`,
								type: "POST",
								contentType: "application/json;odata=verbose",
								headers: {
									"Accept": "application/json;odata=verbose",
									"X-RequestDigest": $('#__REQUESTDIGEST').val()
								}
							}).then(response => {
								return "Success";
							})
							.catch(err => {
								//console.log(`        error calling workflow [${itemId}], error=[${err}]`);
								throw err;
							})
					});
				}
				else {

				}
		},

		async _deleteAllFiles(bundledObject) {
			// Delete multiple files. Pass the bundledObject as an array of objects.
			const self = this
			const resources = []
			for (const item in bundledObject) {
				await self._deleteFile(bundledObject[item]).then(response => { resources.push(response) })
			}
			return resources
		},


		async _downloadFile(fileServerRelativeUrl) {
			//INPUT : string fileServerRelativeUrl
			let url = fileServerRelativeUrl;
			if (fileServerRelativeUrl.indexOf("https") > -1) {
				url = fileServerRelativeUrl
			} else {
				url = process.env.VUE_APP_baseUrl + fileServerRelativeUrl
			}
			vm.$http({
				url: url,
				method: "GET",
				responseType: "blob"
			}).then((response) => {
				FileSaver.saveAs(response.data, fileServerRelativeUrl.split('/').pop());
				return {
					"status": "Success"
				}
				// const url = window.URL.createObjectURL(new Blob([response.data]));
				// const link = document.createElement('a');
				// link.href = url;
				// link.setAttribute('download', fileServerRelativeUrl.split('/').pop());
				// document.body.appendChild(link);
				// link.click();
			})
		},


		async _downloadFilesZip(fileUrlArray, zipFileName) {
			//INPUTS
			// fileUrlArray : Array containing fileServerRelativeURL ex:  ["url1","url2"]
			// zipFileName : name of the Zip file ex Documents.zip 
			let promises = [];
			let zip = new JSZip();
			let count = 0;
			//let zipFilename = "Documents.zip";

			fileUrlArray.forEach(function (fileUrl) {
				let url = fileUrl;
				if (fileUrl.indexOf("https") > -1) {
					url = fileUrl
				} else {
					url = process.env.VUE_APP_baseUrl + fileUrl
				}
				promises.push(
					vm.$http({
						url: url,
						method: "GET",
						responseType: "blob"
					})
				)
			})

			Promise.all(promises).then((...args) => {
				for (let i = 0; i < args[0].length; i++) {
					//let fileName = fileUrlArray[count].split('/').pop()
					////console.log(args[i])
					let fileName = args[0][i].config.url.split('/').pop()
					zip.file(fileName, args[0][i].data)
					count++;
					if (count == fileUrlArray.length) {
						zip.generateAsync({
							type: "blob",
							compression: "DEFLATE",
							compressionOptions: { level: 9 }
						}).then(function (content) {
							saveAs(content, zipFileName);
							return {
								"status": "Success"
							}
						})
					}
				}
			})
		},
		async getPreviousCurrentTaxPeriods(){
			return vm.$http({
				url: process.env.VUE_APP_baseUrl + '/api/TaxPeriod/PreviousCurrent',
				method: 'GET'
			})
			.then(response => response.data);
		},
		async rollForwardFMVStatementFootnotes(){
			return vm.$http({
				url: process.env.VUE_APP_baseUrl + '/api/FMVStatementFootnote/RollForward',
				method: 'POST'
			})
			.then(response => response);
		}
	}
}


